import { render, staticRenderFns } from "./BlockUnblock.vue?vue&type=template&id=7b40386d&"
import script from "./BlockUnblock.vue?vue&type=script&lang=js&"
export * from "./BlockUnblock.vue?vue&type=script&lang=js&"
import style0 from "./BlockUnblock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports